'use client';

import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import { useEffect, useRef } from 'react';
export default function UserHasAction() {
    const hasInitFlag = useRef(false); //用于只执行1次
    // 用户有动作了
    const userActionCallback = () => {
        if (hasInitFlag.current) {
            return;
        }
        hasInitFlag.current = true;
        EcoDesignEventsBus.emit('UserHasAction-start'); // 触发全局事件,用于全局的性能优化
        try {
            window.removeEventListener('scroll', addEventHandleScroll);
            document.body.removeEventListener('click', documentClickHandle);
        } catch (error) {}
    };
    // 绑定事件-滚动
    const addEventHandleScroll = () => {
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        if (scrollTop < 100) {
            return;
        }
        // 要执行的事件
        userActionCallback();
    };
    // 绑定事件-点击
    const documentClickHandle = () => {
        // 要执行的事件
        userActionCallback();
    };
    useEffect(() => {
        const initHandle = () => {
            window.addEventListener('scroll', addEventHandleScroll);
            document.body.addEventListener('click', documentClickHandle);
        };
        initHandle();
    }, []);

    return null;
}
